import script from "./AppNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotifications.vue?vue&type=style&index=0&id=14d7ddab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d7ddab"]])

export default __exports__